import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import RareBoxLogo from "../Logos/RareBoxLogo";
import { GlobalState } from "./GlobalContext";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import { Outlet } from "react-router-dom";
import { AuthState } from "./AuthContext";
import { createSessionData } from "components/Reports/Reports";

const ReportsContext = createContext();
// api url

export function useWebSocketOpen() {
  const { setSnackBarOpen, setSnackBar, snackBar } = GlobalState();

  const checkConnection = (ws, showSnakBar = true) => {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      showSnakBar && setSnackBarOpen(true);
      setSnackBar({
        ...snackBar,
        message: "Unable to send. Not connected to server. Please refresh the page.",
        severity: "error",
        anchorOrigin: { horizontal: "center", vertical: "top" },
      });
      return false;
    }
    return true;
  };

  return { checkConnection };
}

function useIdleTimer(onIdle, onActive, idleTime = 30 * 60 * 1000) { // 10 mins
  const timer = useRef(null);
  const [isIdle, setIsIdle] = useState(false);

  const resetTimer = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setIsIdle(true);
      onIdle?.();
    }, idleTime);
  };

  const handleActivity = () => {
    if (isIdle) {
      setIsIdle(false);
      onActive?.();
    }
    resetTimer();
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, handleActivity));
    resetTimer();
    return () => {
      clearTimeout(timer.current);
      events.forEach((e) => window.removeEventListener(e, handleActivity));
    };
  }, [isIdle]);
}

const ReportsProvider = ({ children }) => {
	const [filter, setFilter] = useState();
	const [loading, setLoading] = useState(false);
	const [reportLoading, setReportLoading] = useState(false);
	const [saleImDropdowns, setSaleImDropdowns] = useState();
	const { rootPath, setRootPath, setLoginUser,setLoadingOpen } = GlobalState();
	const [socket, setSocket] = useState(null);
	const [comments, setComments] = useState([]);
	const [allUsers, setAllUsers] = useState([]);
	const [notifyCount, setNotifyCount] = useState(0);
	const [sessionData, setSessionData] = useState([]);
	const [service, setService] = useState([]);
	const { user} = AuthState();
	const [loadPages, setLoadpages] = useState(true);

	const wsRef = useRef(null);
	const sessionRef = useRef(null);
	sessionRef.current = sessionData;


	const closeWs = useCallback(() => {
		console.log("socket1")
		const ws = wsRef.current;
		const session = sessionRef.current;
		if (ws && ws.readyState === WebSocket.OPEN) {
			ws.send(JSON.stringify({ action: "close", session_id: session?.session_id }));
			setSessionData([]);
			ws.close();
	}
	}, []);



	const connectWebSocket = () =>{
		setLoadingOpen(true)
	const token = localStorage.getItem("user_token")
    const ws = new WebSocket(`${process.env.REACT_APP_FAST_APP_WS_URL}/ws?token=${token}`);
	// const ws = new WebSocket(`ws://127.0.0.1:8000/ws?token=${token}`);
	wsRef.current = ws;
    ws.onopen = () => {
      console.log("✅ Connected to WebSocket");
		ws.send(JSON.stringify(createSessionData({email: user?.email, name: service?.key})));
		// setLoadpages(true)
    };

	ws.onmessage = (event) => {
		const data = JSON.parse(event.data);
		if (data?.action === "session_create") {
			setSessionData(data);
			setLoadpages(true)
		}
		setLoadingOpen(false);
	};

    ws.onclose = () => {
		setLoadingOpen(false);
      console.log("❌ WebSocket connection closed");
    };

    ws.onerror = (error) => {
      console.error("⚠️ WebSocket error:", error);
    };

    setSocket(ws);
   }


   // 💤 When idle more than 10min → disconnect
	 // 🟢 When user active again → reconnect
	 useIdleTimer(
	   () => {
		 console.log("User idle > 30min. Closing connection...");
	   //   disconnectWebSocket();
	  closeWs()
	   },
	   () => {
		 console.log("User active again. Reconnecting...");
		//  connectWebSocket();
   
	   },
	   30 * 60 * 1000
	 );
   
	useEffect(() => {
		console.log("called use effect")
		// connectWebSocket();
   
	   // cleanup when component unmounts
	window.addEventListener("beforeunload", closeWs);
	   return () => {
		closeWs()
		console.log("beforeunload")
		window.removeEventListener("beforeunload", closeWs);
	};
	 }, [setComments]);
	 console.log("called use effect1", socket, notifyCount)
	return (
		<ReportsContext.Provider
			value={{
				filter,
				setFilter,
				loading,
				setLoading,
				reportLoading,
				setReportLoading,
				saleImDropdowns,
				setSaleImDropdowns,
				socket,
				setSocket,
				comments,
				setComments,
				allUsers,
				setAllUsers,
				notifyCount,
				setNotifyCount,
				sessionData,
				setSessionData,
				service,
				setService,
			}}>
			{loading ? (
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			) : (
				loadPages ?  <Outlet /> : null
			)}
		</ReportsContext.Provider>
	);
};

export const ReportsState = () => {
	return useContext(ReportsContext);
};

export default ReportsProvider;
